import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { store } from './store';
import { Provider } from 'react-redux';
import { DAppProvider, Goerli, Mainnet } from '@usedapp/core';

ReactDOM.render(
  <Provider store={store}>
    <DAppProvider
      config={{
        networks: [Goerli, Mainnet],
        notifications: {
          expirationPeriod: 1000, // millisec
          checkInterval: 1000,
        },
      }}
    >
      <App />
    </DAppProvider>
  </Provider>,
  document.getElementById('root')
);
